import { useMediaQuery } from "@mui/material"
import BrokerWeb from "./BrokerWeb"
import BrokerMob from "./BrokerMob"
export default function BrokerHome() {
    const isSmallScreen = useMediaQuery("(max-width:1000px)");
    return isSmallScreen ? <BrokerMob /> : <BrokerWeb />;

}
